module.exports = __webpack_public_path__ + "static/nightmare-a87fe46d96a54a8cb948e7d230879173.jpg";